import { getTheme } from "./getters";

export default getTheme;
